class FeaturedBlog extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  async initSwiper() {
    new Swiper(this.querySelector('.featured-blog__swiper'), {
      slidesPerView: 1.1,
      spaceBetween: 12,
      loop: true,

      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 0,
          navigation: {
            nextEl: '.featured-blog__swiper-next',
            prevEl: '.featured-blog__swiper-prev',
          },
          pagination: false,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 0,
          navigation: {
            nextEl: '.featured-blog__swiper-next',
            prevEl: '.featured-blog__swiper-prev',
          },
        },
      },
    });
  }
}

customElements.define('featured-blog', FeaturedBlog);
